export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  UUID: any;
  DateTime: any;
  LanguageCode: any;
  Slug: any;
  SHA1: any;
  JSONObject: any;
  JSON: any;
  Upload: any;
};

export type AudioContent = {
   __typename?: 'AudioContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: AudioContentData;
};

export type AudioContentData = {
   __typename?: 'AudioContentData';
  title: Array<HtmlTranslation>;
  description: Array<HtmlTranslation>;
  audioRefs: Array<I18nRef>;
  audio: Array<MediaAudioTranslation>;
  i18n: AudioContentDataI18n;
};


export type AudioContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type AudioContentDataI18n = {
   __typename?: 'AudioContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
  audio?: Maybe<MediaAudioTranslation>;
};

export type AudioContentDataInput = {
  title: Array<HtmlTranslationInput>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  audioRefs: Array<I18nRefInput>;
};

export type AudioContentList = {
   __typename?: 'AudioContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<AudioContent>;
};

export type AudioFile = {
   __typename?: 'AudioFile';
  url: Scalars['String'];
  hash: Scalars['SHA1'];
  name: Scalars['String'];
  contentType: Scalars['String'];
  size: Scalars['Int'];
  duration: Scalars['Float'];
};

export type AudioGuide = {
   __typename?: 'AudioGuide';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['String']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  tracks: Array<AudioGuideTrack>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type AudioGuideI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type AudioGuideContent = {
   __typename?: 'AudioGuideContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: AudioGuideContentData;
};

export type AudioGuideContentData = {
   __typename?: 'AudioGuideContentData';
  id?: Maybe<Scalars['UUID']>;
  audioGuide?: Maybe<AudioGuide>;
};

export type AudioGuideContentList = {
   __typename?: 'AudioGuideContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<AudioGuideContent>;
};

export type AudioGuideList = {
   __typename?: 'AudioGuideList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<AudioGuide>;
};

export type AudioGuideTrack = {
   __typename?: 'AudioGuideTrack';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: AudioGuideTrackI18n;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  text?: Maybe<Array<HtmlTranslation>>;
  audio: Array<MediaAudioTranslation>;
  video: Array<MediaVideoTranslation>;
  audioGuides: Array<AudioGuide>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type AudioGuideTrackI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type AudioGuideTrackContent = {
   __typename?: 'AudioGuideTrackContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: AudioGuideTrackContentData;
};

export type AudioGuideTrackContentData = {
   __typename?: 'AudioGuideTrackContentData';
  id?: Maybe<Scalars['UUID']>;
  audioGuideTrack?: Maybe<AudioGuideTrack>;
};

export type AudioGuideTrackContentList = {
   __typename?: 'AudioGuideTrackContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<AudioGuideTrackContent>;
};

export type AudioGuideTrackI18n = {
   __typename?: 'AudioGuideTrackI18n';
  title?: Maybe<HtmlTranslation>;
  abstract?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
  text?: Maybe<StringTranslation>;
  audio?: Maybe<MediaAudioTranslation>;
  video?: Maybe<MediaVideoTranslation>;
};

export type AudioGuideTrackList = {
   __typename?: 'AudioGuideTrackList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<AudioGuideTrack>;
};

export enum AuthRole {
  System = 'system',
  Owner = 'owner',
  Admin = 'admin',
  Editor = 'editor'
}

export type AuthUser = {
   __typename?: 'AuthUser';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  email: Scalars['String'];
  username: Scalars['String'];
  roles: Array<AuthRole>;
};

export type CardRef = {
   __typename?: 'CardRef';
  imageId: Scalars['UUID'];
  options?: Maybe<Scalars['JSON']>;
};

export type CardRefInput = {
  imageId: Scalars['UUID'];
  options?: Maybe<Scalars['JSON']>;
};

export type Collection = {
   __typename?: 'Collection';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  style?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<MediaImage>;
  pointsOfInterest: PointOfInterestList;
  enablePreview?: Maybe<Scalars['Boolean']>;
  locks: Array<Lock>;
  placeholders: Array<Placeholder>;
  duration?: Maybe<Scalars['Float']>;
};


export type CollectionI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};


export type CollectionPointsOfInterestArgs = {
  language?: Maybe<Scalars['LanguageCode']>;
  state?: Maybe<ResourceState>;
  pagination?: Maybe<PaginationArgs>;
};

export type CollectionContent = {
   __typename?: 'CollectionContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: CollectionContentData;
};

export type CollectionContentData = {
   __typename?: 'CollectionContentData';
  id?: Maybe<Scalars['UUID']>;
  collection?: Maybe<Collection>;
};

export type CollectionContentList = {
   __typename?: 'CollectionContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<CollectionContent>;
};

export type CollectionList = {
   __typename?: 'CollectionList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<Collection>;
};

export type ConsumerInfo = {
   __typename?: 'ConsumerInfo';
  usedAs?: Maybe<Scalars['String']>;
  fieldPath?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
};

export type Content = AudioContent | AudioGuideContent | AudioGuideTrackContent | CollectionContent | ImageContent | ImageGalleryContent | PersonContent | PointOfInterestContent | PuzzleContent | QuizContent | QuestionContent | TextContent | VideoContent | SurveyContent | PopupContent | MemoryContent | TimelineContent | ImageComparisonSliderContent | EmbedLinkContent;

export type ContentList = {
   __typename?: 'ContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<Content>;
};

export type ContentOptions = {
   __typename?: 'ContentOptions';
  isAdditionalContent?: Maybe<Scalars['Boolean']>;
};

export type ContentType = {
   __typename?: 'ContentType';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  slug: Scalars['Slug'];
  title: Array<StringTranslation>;
  description: Array<StringTranslation>;
  icon: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  schemaURL: Scalars['String'];
};

export enum ContentTypeSlug {
  Audio = 'Audio',
  AudioGuide = 'AudioGuide',
  AudioGuideTrack = 'AudioGuideTrack',
  Collection = 'Collection',
  Image = 'Image',
  ImageGallery = 'ImageGallery',
  Person = 'Person',
  PointOfInterest = 'PointOfInterest',
  Puzzle = 'Puzzle',
  Question = 'Question',
  Quiz = 'Quiz',
  Text = 'Text',
  Video = 'Video',
  Survey = 'Survey',
  Popup = 'Popup',
  Memory = 'Memory',
  Timeline = 'Timeline',
  ImageComparisonSlider = 'ImageComparisonSlider',
  EmbedLink = 'EmbedLink'
}

export type CreatePlaceholderArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  shortCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaceholderType>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<UpdateMediaArgs>;
  data?: Maybe<Scalars['JSON']>;
  target?: Maybe<Scalars['JSON']>;
  position: GeometryPointInput;
  marker?: Maybe<Scalars['JSON']>;
  parentId?: Maybe<Scalars['UUID']>;
  parent?: Maybe<UpdatePlaceholderArgs>;
  children?: Maybe<Array<CreatePlaceholderArgs>>;
  layerId?: Maybe<Scalars['UUID']>;
  layer?: Maybe<UpdateLayerArgs>;
  pointOfInterestId?: Maybe<Scalars['UUID']>;
  pointOfInterest?: Maybe<UpdatePointOfInterestInput>;
  collectionId?: Maybe<Scalars['UUID']>;
  collection?: Maybe<UpdateCollectionArgs>;
  duration?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
};

export type CreatePresentableResourceArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
};

export type CreateResourceArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CreateStylizedPresentableResourceArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  style?: Maybe<Scalars['JSON']>;
};

export type CropOptions = {
  x: Scalars['Int'];
  y: Scalars['Int'];
  width: Scalars['Int'];
  height: Scalars['Int'];
  rotate: Scalars['Int'];
  scaleX: Scalars['Float'];
  scaleY: Scalars['Float'];
};

export type Dataset = {
   __typename?: 'Dataset';
  key: Scalars['String'];
  value: Scalars['JSON'];
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type DataToPreload = {
   __typename?: 'DataToPreload';
  resources?: Maybe<Array<ResourceToPreload>>;
  files?: Maybe<Array<FileToPreload>>;
  configuration?: Maybe<Scalars['JSONObject']>;
};

export enum DataToPreloadStrategy {
  Inherit = 'inherit',
  Force = 'force',
  Disable = 'disable',
  ReactNativeWebView = 'reactNativeWebView'
}


export type EmbedLinkContent = {
   __typename?: 'EmbedLinkContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: EmbedLinkContentData;
};

export type EmbedLinkContentData = {
   __typename?: 'EmbedLinkContentData';
  text: Array<HtmlTranslation>;
  textButton: Array<HtmlTranslation>;
  i18n: EmbedLinkContentDataI18n;
  url: Array<StringTranslation>;
  options?: Maybe<Scalars['JSON']>;
};


export type EmbedLinkContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type EmbedLinkContentDataI18n = {
   __typename?: 'EmbedLinkContentDataI18n';
  text?: Maybe<HtmlTranslation>;
  textButton?: Maybe<HtmlTranslation>;
  url?: Maybe<StringTranslation>;
};

export type EmbedLinkContentDataInput = {
  text: Array<HtmlTranslationInput>;
  textButton: Array<HtmlTranslationInput>;
  url: Array<StringTranslationInput>;
  options?: Maybe<Scalars['JSON']>;
};

export type EmbedLinkContentList = {
   __typename?: 'EmbedLinkContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<EmbedLinkContent>;
};

export type FileToPreload = {
   __typename?: 'FileToPreload';
  mediaType: MediaType;
  url: Scalars['String'];
};

export type FileUploadInfo = {
   __typename?: 'FileUploadInfo';
  name: Scalars['String'];
  path: Scalars['String'];
  mime: Scalars['String'];
};

export type GeometryPoint = {
   __typename?: 'GeometryPoint';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  unit?: Maybe<PlaceholderUnit>;
};

export type GeometryPointInput = {
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
  unit?: Maybe<PlaceholderUnit>;
};

export type Html = {
   __typename?: 'HTML';
  text: Scalars['String'];
  html: Scalars['String'];
};

export type HtmlInput = {
  text: Scalars['String'];
  html: Scalars['String'];
};

export type HtmlTranslation = {
   __typename?: 'HTMLTranslation';
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: Html;
};

export type HtmlTranslationInput = {
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: HtmlInput;
};

export type I18nRef = {
   __typename?: 'I18nRef';
  id: Scalars['UUID'];
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
};

export type I18nRefInput = {
  id: Scalars['UUID'];
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
};

export enum I18nTarget {
  Child = 'child',
  SignLanguage = 'signLanguage'
}

export type ImageComparisonSliderContent = {
   __typename?: 'ImageComparisonSliderContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: ImageComparisonSliderContentData;
};

export type ImageComparisonSliderContentData = {
   __typename?: 'ImageComparisonSliderContentData';
  title: Array<HtmlTranslation>;
  text: Array<HtmlTranslation>;
  leftImageId: Scalars['UUID'];
  leftImage: MediaImage;
  rightImageId: Scalars['UUID'];
  rightImage: MediaImage;
  i18n: ImageComparisonSliderContentDataI18n;
  options?: Maybe<Scalars['JSON']>;
};


export type ImageComparisonSliderContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type ImageComparisonSliderContentDataI18n = {
   __typename?: 'ImageComparisonSliderContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  text?: Maybe<HtmlTranslation>;
};

export type ImageComparisonSliderContentDataInput = {
  title: Array<HtmlTranslationInput>;
  text: Array<HtmlTranslationInput>;
  leftImageId: Scalars['UUID'];
  rightImageId: Scalars['UUID'];
  options?: Maybe<Scalars['JSON']>;
};

export type ImageComparisonSliderContentList = {
   __typename?: 'ImageComparisonSliderContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<ImageComparisonSliderContent>;
};

export type ImageContent = {
   __typename?: 'ImageContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: ImageContentData;
};

export type ImageContentData = {
   __typename?: 'ImageContentData';
  title: Array<HtmlTranslation>;
  description: Array<HtmlTranslation>;
  imageRefs: Array<I18nRef>;
  image: Array<MediaImageTranslation>;
  i18n: ImageContentDataI18n;
};


export type ImageContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type ImageContentDataI18n = {
   __typename?: 'ImageContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
  image?: Maybe<MediaImageTranslation>;
};

export type ImageContentDataInput = {
  title: Array<HtmlTranslationInput>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  imageRefs: Array<I18nRefInput>;
};

export type ImageContentList = {
   __typename?: 'ImageContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<ImageContent>;
};

export type ImageFile = {
   __typename?: 'ImageFile';
  url: Scalars['String'];
  hash: Scalars['SHA1'];
  name: Scalars['String'];
  contentType: Scalars['String'];
  size: Scalars['Int'];
  width: Scalars['Int'];
  height: Scalars['Int'];
  ratio: Scalars['String'];
};

export type ImageFormat = {
   __typename?: 'ImageFormat';
  name: Scalars['String'];
  file: ImageFile;
};

export type ImageGalleryContent = {
   __typename?: 'ImageGalleryContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: ImageGalleryContentData;
};

export type ImageGalleryContentData = {
   __typename?: 'ImageGalleryContentData';
  title: Array<HtmlTranslation>;
  description?: Maybe<Array<HtmlTranslation>>;
  images: Array<ImageContentData>;
  i18n: ImageGalleryContentDataI18n;
};


export type ImageGalleryContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type ImageGalleryContentDataI18n = {
   __typename?: 'ImageGalleryContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
  images: Array<ImageContentDataI18n>;
};

export type ImageGalleryContentDataInput = {
  title: Array<HtmlTranslationInput>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  images: Array<ImageContentDataInput>;
};

export type ImageGalleryContentList = {
   __typename?: 'ImageGalleryContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<ImageGalleryContent>;
};

export type InformationMessage = {
   __typename?: 'InformationMessage';
  status: Scalars['String'];
  message: Scalars['String'];
};



export type Language = {
   __typename?: 'Language';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  nameI18n: Array<StringTranslation>;
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  flag: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  position?: Maybe<Scalars['Int']>;
  iso: Scalars['String'];
};


export type LanguageI18n = {
   __typename?: 'LanguageI18n';
  name?: Maybe<StringTranslation>;
};

export type LanguageInput = {
  name?: Maybe<Array<StringTranslationInput>>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['Int']>;
};

export type LanguageTranslations = {
   __typename?: 'LanguageTranslations';
  name?: Maybe<StringTranslation>;
};

export type Layer = {
   __typename?: 'Layer';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  shortCode?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSONObject']>;
  map?: Maybe<Map>;
  position: GeometryPoint;
  scale?: Maybe<Scalars['Float']>;
  rotation?: Maybe<Scalars['Float']>;
  geographyTransformationMatrix?: Maybe<Array<Array<Scalars['Float']>>>;
  placeholders: Array<Placeholder>;
  geoPoints?: Maybe<Array<MapGeoPoint>>;
  isGeolocalized: Scalars['Boolean'];
};


export type LayerI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type Lock = {
   __typename?: 'Lock';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  slug: Scalars['Slug'];
  name?: Maybe<Array<StringTranslation>>;
  description?: Maybe<Array<StringTranslation>>;
  data?: Maybe<Scalars['JSONObject']>;
};

export type LockI18n = {
   __typename?: 'LockI18n';
  unlockingInformation?: Maybe<HtmlTranslation>;
};

export type LockList = {
   __typename?: 'LockList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<Lock>;
};

export type Map = {
   __typename?: 'Map';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  shortCode?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  configuration?: Maybe<Scalars['JSON']>;
  layers: Array<Layer>;
  isGeolocalized: Scalars['Boolean'];
  type?: Maybe<MapType>;
};


export type MapI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type MapGeoPoint = {
   __typename?: 'MapGeoPoint';
  position: GeometryPoint;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  altitude?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
};

export type MapGeoPointInput = {
  position: GeometryPointInput;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  altitude?: Maybe<Scalars['Float']>;
  color?: Maybe<Scalars['String']>;
};

export enum MapType {
  Threejs = 'threejs',
  Leaflet = 'leaflet'
}

export type MediaAudio = {
   __typename?: 'MediaAudio';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  slug?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  usedBy: Array<UseContextConsumer>;
  name?: Maybe<Scalars['String']>;
  file: AudioFile;
  imageId?: Maybe<Scalars['String']>;
  image?: Maybe<MediaImage>;
};

export type MediaAudioList = {
   __typename?: 'MediaAudioList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<MediaAudio>;
};

export type MediaAudioTranslation = {
   __typename?: 'MediaAudioTranslation';
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: MediaAudio;
};

export type MediaImage = {
   __typename?: 'MediaImage';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  slug?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  usedBy: Array<UseContextConsumer>;
  originalImageId?: Maybe<Scalars['String']>;
  originalImage?: Maybe<MediaImage>;
  name?: Maybe<Scalars['String']>;
  file: ImageFile;
  formats?: Maybe<Array<ImageFormat>>;
  versions: Array<MediaImage>;
};

export type MediaImageList = {
   __typename?: 'MediaImageList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<MediaImage>;
};

export type MediaImageTranslation = {
   __typename?: 'MediaImageTranslation';
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: MediaImage;
};

export enum MediaType {
  Image = 'Image',
  Video = 'Video',
  Audio = 'Audio'
}

export type MediaVideo = {
   __typename?: 'MediaVideo';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  slug?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  usedBy: Array<UseContextConsumer>;
  name?: Maybe<Scalars['String']>;
  file: VideoFile;
  screenshots: Array<VideoScreenshot>;
};

export type MediaVideoList = {
   __typename?: 'MediaVideoList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<MediaVideo>;
};

export type MediaVideoTranslation = {
   __typename?: 'MediaVideoTranslation';
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: MediaVideo;
};

export type MemoryContent = {
   __typename?: 'MemoryContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: MemoryContentData;
};

export type MemoryContentCard = {
   __typename?: 'MemoryContentCard';
  image: MediaImage;
  options?: Maybe<Scalars['JSON']>;
};

export type MemoryContentData = {
   __typename?: 'MemoryContentData';
  cards: Array<MemoryContentCard>;
  cardRefs: Array<CardRef>;
  title: Array<HtmlTranslation>;
  text: Array<HtmlTranslation>;
  i18n: MemoryContentDataI18n;
  options?: Maybe<Scalars['JSON']>;
  versoImageId?: Maybe<Scalars['UUID']>;
  versoImage?: Maybe<MediaImage>;
};


export type MemoryContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type MemoryContentDataI18n = {
   __typename?: 'MemoryContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  text?: Maybe<HtmlTranslation>;
};

export type MemoryContentDataInput = {
  cardRefs: Array<CardRefInput>;
  title: Array<HtmlTranslationInput>;
  text: Array<HtmlTranslationInput>;
  options?: Maybe<Scalars['JSON']>;
  versoImageId?: Maybe<Scalars['UUID']>;
};

export type MemoryContentList = {
   __typename?: 'MemoryContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<MemoryContent>;
};

export type Mutation = {
   __typename?: 'Mutation';
  clearCache: Scalars['String'];
  cacheContent: Scalars['String'];
  downloadFiles: Scalars['String'];
  singleUpload: FileUploadInfo;
  createAudioGuide: AudioGuide;
  createAudioGuideTrack: AudioGuideTrack;
  deleteAudioGuide?: Maybe<Scalars['String']>;
  deleteAudioGuideTrack?: Maybe<Scalars['String']>;
  updateAudioGuide?: Maybe<AudioGuide>;
  updateAudioGuideTrack?: Maybe<AudioGuideTrack>;
  createAuthUser: AuthUser;
  deleteAuthUser?: Maybe<Scalars['String']>;
  updateAuthUser?: Maybe<AuthUser>;
  createCollection: Collection;
  deleteCollection?: Maybe<Scalars['String']>;
  updateCollection?: Maybe<Collection>;
  deleteContent?: Maybe<Scalars['String']>;
  createQuestionContent: QuestionContent;
  updateQuestionContent?: Maybe<QuestionContent>;
  createQuizContent: QuizContent;
  updateQuizContent?: Maybe<QuizContent>;
  createSurveyContent: SurveyContent;
  updateSurveyContent?: Maybe<SurveyContent>;
  createAudioContent: AudioContent;
  updateAudioContent?: Maybe<AudioContent>;
  createAudioGuideContent: AudioGuideContent;
  updateAudioGuideContent?: Maybe<AudioGuideContent>;
  createAudioGuideTrackContent: AudioGuideTrackContent;
  updateAudioGuideTrackContent?: Maybe<AudioGuideTrackContent>;
  createCollectionContent: CollectionContent;
  updateCollectionContent?: Maybe<CollectionContent>;
  createImageContent: ImageContent;
  updateImageContent?: Maybe<ImageContent>;
  createImageGalleryContent: ImageGalleryContent;
  updateImageGalleryContent?: Maybe<ImageGalleryContent>;
  createPersonContent: PersonContent;
  updatePersonContent?: Maybe<PersonContent>;
  createPointOfInterestContent: PointOfInterestContent;
  updatePointOfInterestContent?: Maybe<PointOfInterestContent>;
  createPuzzleContent: PuzzleContent;
  updatePuzzleContent?: Maybe<PuzzleContent>;
  createTextContent: TextContent;
  updateTextContent?: Maybe<TextContent>;
  createVideoContent: VideoContent;
  updateVideoContent?: Maybe<VideoContent>;
  createPopupContent: PopupContent;
  updatePopupContent?: Maybe<PopupContent>;
  createMemoryContent: MemoryContent;
  updateMemoryContent?: Maybe<MemoryContent>;
  createTimelineContent: TimelineContent;
  updateTimelineContent?: Maybe<TimelineContent>;
  createImageComparisonSliderContent: ImageComparisonSliderContent;
  updateImageComparisonSliderContent?: Maybe<ImageComparisonSliderContent>;
  createEmbedLinkContent: EmbedLinkContent;
  updateEmbedLinkContent?: Maybe<EmbedLinkContent>;
  deleteDataset?: Maybe<Scalars['String']>;
  storeDataset: Dataset;
  updateLanguage?: Maybe<Language>;
  createMediaAudio: MediaAudio;
  createMediaImage: MediaImage;
  createMediaImageVersion?: Maybe<MediaImage>;
  createMediaVideo: MediaVideo;
  deleteMediaAudio?: Maybe<Scalars['String']>;
  deleteImage?: Maybe<Scalars['String']>;
  deleteMediaVideo?: Maybe<Scalars['String']>;
  updateMediaAudio?: Maybe<MediaAudio>;
  updateMediaImage?: Maybe<MediaImage>;
  updateMediaVideo?: Maybe<MediaVideo>;
  createPerson: Person;
  deletePerson?: Maybe<Scalars['String']>;
  updatePerson?: Maybe<Person>;
  createPointOfInterest: PointOfInterest;
  deletePointOfInterest?: Maybe<Scalars['String']>;
  updatePointOfInterest?: Maybe<PointOfInterest>;
  createQuestion: Question;
  createQuiz: Quiz;
  createQuizScope: QuizScope;
  deleteQuestion?: Maybe<Scalars['String']>;
  deleteQuiz?: Maybe<Scalars['String']>;
  deleteQuizScope?: Maybe<Scalars['String']>;
  storeQuestionAnswer: QuestionAnswer;
  updateQuestion?: Maybe<Question>;
  updateQuiz?: Maybe<Quiz>;
  updateQuizScope?: Maybe<QuizScope>;
  createRealm: Realm;
  deleteRealm?: Maybe<Scalars['String']>;
  updateRealm?: Maybe<Realm>;
  createUser: User;
  deleteUser?: Maybe<Scalars['String']>;
  createLock: Lock;
  deleteLock?: Maybe<Scalars['String']>;
  updateLock?: Maybe<Lock>;
  createMap: Map;
  deleteMap?: Maybe<Scalars['String']>;
  updateMap?: Maybe<Map>;
  deletePlaceholder?: Maybe<Scalars['String']>;
  updateLayer?: Maybe<Layer>;
  updatePlaceholder: Placeholder;
  createPlaceholder: Placeholder;
  createLayer: Layer;
  deleteLayer?: Maybe<Scalars['String']>;
};


export type MutationSingleUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationCreateAudioGuideArgs = {
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['UUID']>;
  audioGuideTrackRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateAudioGuideTrackArgs = {
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['UUID']>;
  text?: Maybe<Array<HtmlTranslationInput>>;
  audioRefs?: Maybe<Array<I18nRefInput>>;
  videoRefs?: Maybe<Array<I18nRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteAudioGuideArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteAudioGuideTrackArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateAudioGuideArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['UUID']>;
  audioGuideTrackRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateAudioGuideTrackArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['UUID']>;
  text?: Maybe<Array<HtmlTranslationInput>>;
  audioRefs?: Maybe<Array<I18nRefInput>>;
  videoRefs?: Maybe<Array<I18nRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateAuthUserArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  username: Scalars['String'];
  password: Scalars['String'];
  roles: Array<AuthRole>;
};


export type MutationDeleteAuthUserArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateAuthUserArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<AuthRole>>;
};


export type MutationCreateCollectionArgs = {
  style?: Maybe<Scalars['JSON']>;
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  pointOfInterestRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  lockRefs?: Maybe<Array<RefInput>>;
  duration?: Maybe<Scalars['Float']>;
  placeholderRefs?: Maybe<Array<RefInput>>;
};


export type MutationDeleteCollectionArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateCollectionArgs = {
  style?: Maybe<Scalars['JSON']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  pointOfInterestRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  lockRefs?: Maybe<Array<RefInput>>;
  duration?: Maybe<Scalars['Float']>;
  placeholderRefs?: Maybe<Array<RefInput>>;
};


export type MutationDeleteContentArgs = {
  id: Scalars['UUID'];
};


export type MutationCreateQuestionContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdateQuestionContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationCreateQuizContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdateQuizContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationCreateSurveyContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdateSurveyContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationCreateAudioContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: AudioContentDataInput;
};


export type MutationUpdateAudioContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<AudioContentDataInput>;
};


export type MutationCreateAudioGuideContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdateAudioGuideContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<RefInput>;
};


export type MutationCreateAudioGuideTrackContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdateAudioGuideTrackContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationCreateCollectionContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdateCollectionContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationCreateImageContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: ImageContentDataInput;
};


export type MutationUpdateImageContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<ImageContentDataInput>;
};


export type MutationCreateImageGalleryContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: ImageGalleryContentDataInput;
};


export type MutationUpdateImageGalleryContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<ImageGalleryContentDataInput>;
};


export type MutationCreatePersonContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: RefInput;
};


export type MutationUpdatePersonContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<RefInput>;
};


export type MutationCreatePointOfInterestContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: PointOfInterestContentDataInput;
};


export type MutationUpdatePointOfInterestContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<PointOfInterestContentDataInput>;
};


export type MutationCreatePuzzleContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: PuzzleContentDataInput;
};


export type MutationUpdatePuzzleContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<PuzzleContentDataInput>;
};


export type MutationCreateTextContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: TextContentDataInput;
};


export type MutationUpdateTextContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<TextContentDataInput>;
};


export type MutationCreateVideoContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: VideoContentDataInput;
};


export type MutationUpdateVideoContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<VideoContentDataInput>;
};


export type MutationCreatePopupContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: PopupContentDataInput;
};


export type MutationUpdatePopupContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<PopupContentDataInput>;
};


export type MutationCreateMemoryContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: MemoryContentDataInput;
};


export type MutationUpdateMemoryContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<MemoryContentDataInput>;
};


export type MutationCreateTimelineContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: TimelineContentDataInput;
};


export type MutationUpdateTimelineContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<TimelineContentDataInput>;
};


export type MutationCreateImageComparisonSliderContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: ImageComparisonSliderContentDataInput;
};


export type MutationUpdateImageComparisonSliderContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<ImageComparisonSliderContentDataInput>;
};


export type MutationCreateEmbedLinkContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data: EmbedLinkContentDataInput;
};


export type MutationUpdateEmbedLinkContentArgs = {
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<EmbedLinkContentDataInput>;
};


export type MutationDeleteDatasetArgs = {
  key: Scalars['String'];
};


export type MutationStoreDatasetArgs = {
  key: Scalars['String'];
  value: Scalars['JSON'];
};


export type MutationUpdateLanguageArgs = {
  data: LanguageInput;
  code: Scalars['LanguageCode'];
};


export type MutationCreateMediaAudioArgs = {
  file: Scalars['Upload'];
  id?: Maybe<Scalars['UUID']>;
};


export type MutationCreateMediaImageArgs = {
  file: Scalars['Upload'];
  id?: Maybe<Scalars['UUID']>;
};


export type MutationCreateMediaImageVersionArgs = {
  cropOptions: CropOptions;
  originalImageId: Scalars['UUID'];
};


export type MutationCreateMediaVideoArgs = {
  file: Scalars['Upload'];
  id?: Maybe<Scalars['UUID']>;
};


export type MutationDeleteMediaAudioArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteImageArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteMediaVideoArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateMediaAudioArgs = {
  credits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  imageId?: Maybe<Scalars['UUID']>;
};


export type MutationUpdateMediaImageArgs = {
  credits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
};


export type MutationUpdateMediaVideoArgs = {
  credits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
};


export type MutationCreatePersonArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages: Array<Scalars['LanguageCode']>;
  name: Array<HtmlTranslationInput>;
  bio: Array<HtmlTranslationInput>;
  bornString?: Maybe<Array<HtmlTranslationInput>>;
  diedString?: Maybe<Array<HtmlTranslationInput>>;
  imageId?: Maybe<Scalars['UUID']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  bornYear?: Maybe<Scalars['Int']>;
  bornMonth?: Maybe<Scalars['Int']>;
  bornDay?: Maybe<Scalars['Int']>;
  diedYear?: Maybe<Scalars['Int']>;
  diedMonth?: Maybe<Scalars['Int']>;
  diedDay?: Maybe<Scalars['Int']>;
};


export type MutationDeletePersonArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdatePersonArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  name?: Maybe<Array<HtmlTranslationInput>>;
  bio?: Maybe<Array<HtmlTranslationInput>>;
  bornString?: Maybe<Array<HtmlTranslationInput>>;
  diedString?: Maybe<Array<HtmlTranslationInput>>;
  imageId?: Maybe<Scalars['UUID']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  bornYear?: Maybe<Scalars['Int']>;
  bornMonth?: Maybe<Scalars['Int']>;
  bornDay?: Maybe<Scalars['Int']>;
  diedYear?: Maybe<Scalars['Int']>;
  diedMonth?: Maybe<Scalars['Int']>;
  diedDay?: Maybe<Scalars['Int']>;
};


export type MutationCreatePointOfInterestArgs = {
  style?: Maybe<Scalars['JSON']>;
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  contentRefs?: Maybe<Array<PointOfInterestContentRefInput>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  audioGuideTrackRefs?: Maybe<Array<SortableRefInput>>;
  lockRefs?: Maybe<Array<RefInput>>;
  duration?: Maybe<Scalars['Float']>;
  placeholderRefs?: Maybe<Array<RefInput>>;
};


export type MutationDeletePointOfInterestArgs = {
  id: Scalars['String'];
};


export type MutationUpdatePointOfInterestArgs = {
  style?: Maybe<Scalars['JSON']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  contentRefs?: Maybe<Array<PointOfInterestContentRefInput>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  audioGuideTrackRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  lockRefs?: Maybe<Array<RefInput>>;
  duration?: Maybe<Scalars['Float']>;
  placeholderRefs?: Maybe<Array<RefInput>>;
};


export type MutationCreateQuestionArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  quizId?: Maybe<Scalars['UUID']>;
  imageId?: Maybe<Scalars['UUID']>;
  scopeRefs?: Maybe<Array<RefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateQuizArgs = {
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  quizScopeId?: Maybe<Scalars['String']>;
  questionRefs?: Maybe<Array<QuestionRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateQuizScopeArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['Slug'];
};


export type MutationDeleteQuestionArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteQuizArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteQuizScopeArgs = {
  id: Scalars['UUID'];
};


export type MutationStoreQuestionAnswerArgs = {
  userId: Scalars['UUID'];
  questionId: Scalars['UUID'];
  quizId?: Maybe<Scalars['UUID']>;
  contentId?: Maybe<Scalars['UUID']>;
  data: Scalars['JSON'];
  submissionId?: Maybe<Scalars['UUID']>;
  language?: Maybe<Scalars['LanguageCode']>;
};


export type MutationUpdateQuestionArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  quizId?: Maybe<Scalars['UUID']>;
  imageId?: Maybe<Scalars['UUID']>;
  scopeRefs?: Maybe<Array<RefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateQuizArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  quizScopeId?: Maybe<Scalars['String']>;
  questionRefs?: Maybe<Array<QuestionRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateQuizScopeArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['Slug'];
};


export type MutationCreateRealmArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
};


export type MutationDeleteRealmArgs = {
  id: Scalars['String'];
};


export type MutationUpdateRealmArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
};


export type MutationCreateUserArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userAgent: Scalars['String'];
  language: Scalars['LanguageCode'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['UUID'];
};


export type MutationCreateLockArgs = {
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['Slug'];
  name?: Maybe<Array<StringTranslationInput>>;
  description?: Maybe<Array<StringTranslationInput>>;
  data?: Maybe<Scalars['JSON']>;
};


export type MutationDeleteLockArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateLockArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Array<StringTranslationInput>>;
  description?: Maybe<Array<StringTranslationInput>>;
  data?: Maybe<Scalars['JSON']>;
};


export type MutationCreateMapArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['UUID']>;
  configuration?: Maybe<Scalars['JSON']>;
  type?: Maybe<MapType>;
};


export type MutationDeleteMapArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateMapArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['UUID']>;
  configuration?: Maybe<Scalars['JSON']>;
  type?: Maybe<MapType>;
};


export type MutationDeletePlaceholderArgs = {
  id: Scalars['UUID'];
};


export type MutationUpdateLayerArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<UpdateMediaArgs>;
  data?: Maybe<Scalars['JSON']>;
  mapId?: Maybe<Scalars['UUID']>;
  position?: Maybe<GeometryPointInput>;
  scale?: Maybe<Scalars['Float']>;
  rotation?: Maybe<Scalars['Float']>;
  placeholders?: Maybe<Array<CreatePlaceholderArgs>>;
  geoPoints?: Maybe<Array<MapGeoPointInput>>;
};


export type MutationUpdatePlaceholderArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  shortCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaceholderType>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<UpdateMediaArgs>;
  data?: Maybe<Scalars['JSON']>;
  target?: Maybe<Scalars['JSON']>;
  position?: Maybe<GeometryPointInput>;
  marker?: Maybe<Scalars['JSON']>;
  parentId?: Maybe<Scalars['UUID']>;
  parent?: Maybe<UpdatePlaceholderArgs>;
  children?: Maybe<Array<CreatePlaceholderArgs>>;
  layerId?: Maybe<Scalars['UUID']>;
  layer?: Maybe<UpdateLayerArgs>;
  pointOfInterestId?: Maybe<Scalars['UUID']>;
  pointOfInterest?: Maybe<UpdatePointOfInterestInput>;
  collectionId?: Maybe<Scalars['UUID']>;
  collection?: Maybe<UpdateCollectionArgs>;
  duration?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
};


export type MutationCreatePlaceholderArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  shortCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaceholderType>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<UpdateMediaArgs>;
  data?: Maybe<Scalars['JSON']>;
  target?: Maybe<Scalars['JSON']>;
  position: GeometryPointInput;
  marker?: Maybe<Scalars['JSON']>;
  parentId?: Maybe<Scalars['UUID']>;
  parent?: Maybe<UpdatePlaceholderArgs>;
  children?: Maybe<Array<CreatePlaceholderArgs>>;
  layerId?: Maybe<Scalars['UUID']>;
  layer?: Maybe<UpdateLayerArgs>;
  pointOfInterestId?: Maybe<Scalars['UUID']>;
  pointOfInterest?: Maybe<UpdatePointOfInterestInput>;
  collectionId?: Maybe<Scalars['UUID']>;
  collection?: Maybe<UpdateCollectionArgs>;
  duration?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
};


export type MutationCreateLayerArgs = {
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  id?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['UUID']>;
  data?: Maybe<Scalars['JSON']>;
  mapId: Scalars['UUID'];
  position: GeometryPointInput;
  scale?: Maybe<Scalars['Float']>;
  rotation?: Maybe<Scalars['Float']>;
  placeholders?: Maybe<Array<CreatePlaceholderArgs>>;
  geoPoints?: Maybe<Array<MapGeoPointInput>>;
};


export type MutationDeleteLayerArgs = {
  id: Scalars['UUID'];
};

export type PaginationArgs = {
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type PaginationOptions = {
   __typename?: 'PaginationOptions';
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type Person = {
   __typename?: 'Person';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  name: Array<HtmlTranslation>;
  bio: Array<HtmlTranslation>;
  bornString?: Maybe<Array<HtmlTranslation>>;
  diedString?: Maybe<Array<HtmlTranslation>>;
  image?: Maybe<MediaImage>;
  i18n: PersonI18n;
  enablePreview?: Maybe<Scalars['Boolean']>;
  bornYear?: Maybe<Scalars['Int']>;
  bornMonth?: Maybe<Scalars['Int']>;
  bornDay?: Maybe<Scalars['Int']>;
  diedYear?: Maybe<Scalars['Int']>;
  diedMonth?: Maybe<Scalars['Int']>;
  diedDay?: Maybe<Scalars['Int']>;
};


export type PersonI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type PersonContent = {
   __typename?: 'PersonContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: PersonContentData;
};

export type PersonContentData = {
   __typename?: 'PersonContentData';
  id: Scalars['UUID'];
  person?: Maybe<Person>;
};

export type PersonContentList = {
   __typename?: 'PersonContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<PersonContent>;
};

export type PersonI18n = {
   __typename?: 'PersonI18n';
  name?: Maybe<HtmlTranslation>;
  bio?: Maybe<HtmlTranslation>;
  bornString?: Maybe<HtmlTranslation>;
  diedString?: Maybe<HtmlTranslation>;
};

export type PersonList = {
   __typename?: 'PersonList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<Person>;
};

export type PersonRefInput = {
  id: Scalars['UUID'];
  roleId?: Maybe<Scalars['UUID']>;
};

export type PersonRole = {
   __typename?: 'PersonRole';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  slug: Scalars['Slug'];
  name: Array<StringTranslation>;
  i18n: PersonRoleI18n;
};


export type PersonRoleI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type PersonRoleI18n = {
   __typename?: 'PersonRoleI18n';
  name?: Maybe<StringTranslation>;
};

export type PersonWithRole = {
   __typename?: 'PersonWithRole';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  name: Array<HtmlTranslation>;
  bio: Array<HtmlTranslation>;
  bornString?: Maybe<Array<HtmlTranslation>>;
  diedString?: Maybe<Array<HtmlTranslation>>;
  image?: Maybe<MediaImage>;
  i18n: PersonI18n;
  enablePreview?: Maybe<Scalars['Boolean']>;
  bornYear?: Maybe<Scalars['Int']>;
  bornMonth?: Maybe<Scalars['Int']>;
  bornDay?: Maybe<Scalars['Int']>;
  diedYear?: Maybe<Scalars['Int']>;
  diedMonth?: Maybe<Scalars['Int']>;
  diedDay?: Maybe<Scalars['Int']>;
  role?: Maybe<PersonRole>;
};


export type PersonWithRoleI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type Placeholder = {
   __typename?: 'Placeholder';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  shortCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['UUID']>;
  image: MediaImage;
  data?: Maybe<Scalars['JSONObject']>;
  target?: Maybe<Scalars['JSONObject']>;
  parentId?: Maybe<Scalars['UUID']>;
  parent: Placeholder;
  children: Array<Placeholder>;
  type: PlaceholderType;
  layerId?: Maybe<Scalars['UUID']>;
  layer?: Maybe<Layer>;
  map?: Maybe<Map>;
  position: GeometryPoint;
  marker?: Maybe<Scalars['JSON']>;
  duration?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
};


export type PlaceholderI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export enum PlaceholderType {
  Content = 'content',
  Group = 'group'
}

export enum PlaceholderUnit {
  Geographic = 'geographic',
  Meter = 'meter',
  Pixel = 'pixel',
  MapUnit = 'mapUnit'
}

export type PointOfInterest = {
   __typename?: 'PointOfInterest';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  style?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  image?: Maybe<MediaImage>;
  collections: Array<Collection>;
  paginatedContents: ContentList;
  contents: Array<Content>;
  people: Array<PersonWithRole>;
  audioGuideTracks: Array<AudioGuideTrack>;
  locks: Array<Lock>;
  placeholders: Array<Placeholder>;
  duration?: Maybe<Scalars['Float']>;
};


export type PointOfInterestI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};


export type PointOfInterestPaginatedContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
};

export type PointOfInterestContent = {
   __typename?: 'PointOfInterestContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: PointOfInterestContentData;
};

export type PointOfInterestContentData = {
   __typename?: 'PointOfInterestContentData';
  id: Scalars['String'];
  pointOfInterest?: Maybe<PointOfInterest>;
  headline?: Maybe<Array<HtmlTranslation>>;
  headlineType?: Maybe<PointOfInterestContentHeadlineType>;
  i18n: PointOfInterestContentDataI18n;
  options?: Maybe<Scalars['JSON']>;
};


export type PointOfInterestContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type PointOfInterestContentDataI18n = {
   __typename?: 'PointOfInterestContentDataI18n';
  headline?: Maybe<HtmlTranslation>;
};

export type PointOfInterestContentDataInput = {
  id: Scalars['UUID'];
  headline?: Maybe<Array<HtmlTranslationInput>>;
  headlineType?: Maybe<PointOfInterestContentHeadlineType>;
  options?: Maybe<Scalars['JSON']>;
};

export enum PointOfInterestContentHeadlineType {
  Disabled = 'disabled',
  ReadMore = 'readMore',
  Custom = 'custom'
}

export type PointOfInterestContentList = {
   __typename?: 'PointOfInterestContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<PointOfInterestContent>;
};

export type PointOfInterestContentOptions = {
   __typename?: 'PointOfInterestContentOptions';
  isAdditionalContent?: Maybe<Scalars['Boolean']>;
};

export type PointOfInterestContentOptionsInput = {
  isAdditionalContent?: Maybe<Scalars['Boolean']>;
};

export type PointOfInterestContentRef = {
   __typename?: 'PointOfInterestContentRef';
  id: Scalars['UUID'];
  position: Scalars['Int'];
  options?: Maybe<PointOfInterestContentOptions>;
};

export type PointOfInterestContentRefInput = {
  id: Scalars['UUID'];
  position: Scalars['Int'];
  options?: Maybe<PointOfInterestContentOptionsInput>;
};

export type PointOfInterestList = {
   __typename?: 'PointOfInterestList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<PointOfInterest>;
};

export type PopupContent = {
   __typename?: 'PopupContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: PopupContentData;
};

export type PopupContentData = {
   __typename?: 'PopupContentData';
  timer: Scalars['Int'];
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<MediaImage>;
  title: Array<HtmlTranslation>;
  text: Array<HtmlTranslation>;
  button: Array<HtmlTranslation>;
  i18n: PopupContentDataI18n;
};


export type PopupContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type PopupContentDataI18n = {
   __typename?: 'PopupContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  text?: Maybe<HtmlTranslation>;
  button?: Maybe<HtmlTranslation>;
};

export type PopupContentDataInput = {
  timer: Scalars['Int'];
  imageId?: Maybe<Scalars['UUID']>;
  title: Array<HtmlTranslationInput>;
  text: Array<HtmlTranslationInput>;
  button: Array<HtmlTranslationInput>;
};

export type PopupContentList = {
   __typename?: 'PopupContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<PopupContent>;
};

export type PresentableResourceI18n = {
   __typename?: 'PresentableResourceI18n';
  title?: Maybe<HtmlTranslation>;
  abstract?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
};

export type PuzzleContent = {
   __typename?: 'PuzzleContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: PuzzleContentData;
};

export type PuzzleContentData = {
   __typename?: 'PuzzleContentData';
  xPieces: Scalars['Int'];
  yPieces: Scalars['Int'];
  timer: Scalars['Int'];
  imageId: Scalars['UUID'];
  image?: Maybe<MediaImage>;
  title: Array<HtmlTranslation>;
  description: Array<HtmlTranslation>;
  conclusion?: Maybe<Array<HtmlTranslation>>;
  i18n: PuzzleContentDataI18n;
};


export type PuzzleContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type PuzzleContentDataI18n = {
   __typename?: 'PuzzleContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
  conclusion?: Maybe<HtmlTranslation>;
};

export type PuzzleContentDataInput = {
  xPieces: Scalars['Int'];
  yPieces: Scalars['Int'];
  timer: Scalars['Int'];
  imageId: Scalars['UUID'];
  title: Array<HtmlTranslationInput>;
  description: Array<HtmlTranslationInput>;
  conclusion: Array<HtmlTranslationInput>;
};

export type PuzzleContentList = {
   __typename?: 'PuzzleContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<PuzzleContent>;
};

export type Query = {
   __typename?: 'Query';
  audioGuides: AudioGuideList;
  audioGuide?: Maybe<AudioGuide>;
  audioGuideTracks: AudioGuideTrackList;
  audioGuideTrack?: Maybe<AudioGuideTrack>;
  authUsers: Array<AuthUser>;
  authUser?: Maybe<AuthUser>;
  quizScopes: QuizScopeList;
  quizzes: QuizList;
  quiz?: Maybe<Quiz>;
  questions: QuestionList;
  question?: Maybe<Question>;
  questionContentQuery: QuestionContent;
  questionContents: QuestionContentList;
  quizContentQuery: QuizContent;
  quizContents: QuizContentList;
  surveyContentQuery: SurveyContent;
  surveyContents: SurveyContentList;
  collections: CollectionList;
  collection?: Maybe<Collection>;
  audioContentQuery: AudioContent;
  audioContents: AudioContentList;
  audioGuideContentQuery: AudioGuideContent;
  audioGuideContents: AudioGuideContentList;
  audioGuideTrackContentQuery: AudioGuideTrackContent;
  audioGuideTrackContents: AudioGuideTrackContentList;
  collectionContentQuery: CollectionContent;
  collectionContents: CollectionContentList;
  imageContentQuery: ImageContent;
  imageContents: ImageContentList;
  imageGalleryContentQuery: ImageGalleryContent;
  imageGalleryContents: ImageGalleryContentList;
  personContentQuery: PersonContent;
  personContents: PersonContentList;
  pointOfInterestContentQuery: PointOfInterestContent;
  pointOfInterestContents: PointOfInterestContentList;
  puzzleContentQuery: PuzzleContent;
  puzzleContents: PuzzleContentList;
  textContentQuery: TextContent;
  textContents: TextContentList;
  videoContentQuery: VideoContent;
  videoContents: VideoContentList;
  popupContentQuery: PopupContent;
  popupContents: PopupContentList;
  memoryContentQuery: MemoryContent;
  memoryContents: MemoryContentList;
  timelineContentQuery: TimelineContent;
  timelineContents: TimelineContentList;
  imageComparisonSliderContentQuery: ImageComparisonSliderContent;
  imageComparisonSliderContents: ImageComparisonSliderContentList;
  embedLinkContentQuery: EmbedLinkContent;
  embedLinkContents: EmbedLinkContentList;
  contentTypes: Array<ContentType>;
  contentType?: Maybe<ContentType>;
  datasets: Array<Dataset>;
  dataset?: Maybe<Dataset>;
  languages: Array<Language>;
  language?: Maybe<Language>;
  audios: MediaAudioList;
  audio?: Maybe<MediaAudio>;
  images: MediaImageList;
  image?: Maybe<MediaImage>;
  getImageFiles: Array<Scalars['String']>;
  videos: MediaVideoList;
  video?: Maybe<MediaVideo>;
  people: PersonList;
  person?: Maybe<Person>;
  personRoles: Array<PersonRole>;
  pointsOfInterest: PointOfInterestList;
  pointOfInterest?: Maybe<PointOfInterest>;
  realms: Array<Realm>;
  realm?: Maybe<Realm>;
  search: SearchResult;
  locks: LockList;
  lock?: Maybe<Lock>;
  maps: Array<Map>;
  map?: Maybe<Map>;
  layers: Array<Layer>;
  layer?: Maybe<Layer>;
  placeholders: Array<Placeholder>;
  placeholder?: Maybe<Placeholder>;
  dataToPreload?: Maybe<DataToPreload>;
};


export type QueryAudioGuidesArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryAudioGuideArgs = {
  id: Scalars['UUID'];
};


export type QueryAudioGuideTracksArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryAudioGuideTrackArgs = {
  id: Scalars['UUID'];
};


export type QueryAuthUserArgs = {
  id: Scalars['UUID'];
};


export type QueryQuizScopesArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryQuizzesArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
  state?: Maybe<ResourceState>;
};


export type QueryQuizArgs = {
  id: Scalars['UUID'];
};


export type QueryQuestionsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryQuestionArgs = {
  id: Scalars['UUID'];
};


export type QueryQuestionContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryQuestionContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryQuizContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryQuizContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QuerySurveyContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QuerySurveyContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryCollectionsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
  state?: Maybe<ResourceState>;
  language?: Maybe<Scalars['LanguageCode']>;
};


export type QueryCollectionArgs = {
  id: Scalars['UUID'];
};


export type QueryAudioContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryAudioContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryAudioGuideContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryAudioGuideContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryAudioGuideTrackContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryAudioGuideTrackContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryCollectionContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryCollectionContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryImageContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryImageContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryImageGalleryContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryImageGalleryContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryPersonContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryPersonContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryPointOfInterestContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryPointOfInterestContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryPuzzleContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryPuzzleContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryTextContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryTextContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryVideoContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryVideoContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryPopupContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryPopupContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryMemoryContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryMemoryContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryTimelineContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryTimelineContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryImageComparisonSliderContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryImageComparisonSliderContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryEmbedLinkContentQueryArgs = {
  id: Scalars['UUID'];
};


export type QueryEmbedLinkContentsArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryContentTypeArgs = {
  id?: Maybe<Scalars['UUID']>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryDatasetArgs = {
  key: Scalars['String'];
};


export type QueryLanguagesArgs = {
  isEnabled?: Maybe<Scalars['Boolean']>;
};


export type QueryLanguageArgs = {
  code: Scalars['String'];
};


export type QueryAudiosArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryAudioArgs = {
  id: Scalars['UUID'];
};


export type QueryImagesArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryImageArgs = {
  id: Scalars['UUID'];
};


export type QueryVideosArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryVideoArgs = {
  id: Scalars['UUID'];
};


export type QueryPeopleArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryPersonArgs = {
  id: Scalars['UUID'];
};


export type QueryPointsOfInterestArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
  state?: Maybe<ResourceState>;
};


export type QueryPointOfInterestArgs = {
  id: Scalars['UUID'];
};


export type QueryRealmArgs = {
  id: Scalars['String'];
};


export type QuerySearchArgs = {
  language?: Maybe<Scalars['LanguageCode']>;
  text: Scalars['String'];
};


export type QueryLocksArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
};


export type QueryLockArgs = {
  id?: Maybe<Scalars['UUID']>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryMapArgs = {
  id: Scalars['String'];
};


export type QueryLayersArgs = {
  state?: Maybe<ResourceState>;
  mapId?: Maybe<Scalars['String']>;
};


export type QueryLayerArgs = {
  id: Scalars['String'];
};


export type QueryPlaceholdersArgs = {
  state?: Maybe<ResourceState>;
  layerId?: Maybe<Scalars['String']>;
  mapId?: Maybe<Scalars['String']>;
  pointOfInterestId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
};


export type QueryPlaceholderArgs = {
  id: Scalars['String'];
};


export type QueryDataToPreloadArgs = {
  strategy?: Maybe<DataToPreloadStrategy>;
  language: Scalars['LanguageCode'];
  languages: Array<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
};

export type Question = {
   __typename?: 'Question';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['Slug']>;
  type: QuestionType;
  data: Scalars['JSONObject'];
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<MediaImage>;
  quizRefs: Array<Ref>;
  quizzes: Array<Quiz>;
  scopeRefs: Array<Ref>;
  scopes: Array<QuizScope>;
  answers: QuestionAnswerList;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type QuestionI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};


export type QuestionAnswersArgs = {
  pagination?: Maybe<PaginationArgs>;
  sort?: Maybe<SortArgs>;
  contentId?: Maybe<Scalars['UUID']>;
  userId?: Maybe<Scalars['UUID']>;
  quizId?: Maybe<Scalars['UUID']>;
};

export type QuestionAnswer = {
   __typename?: 'QuestionAnswer';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['UUID'];
  user: User;
  questionId: Scalars['UUID'];
  question: Question;
  quizId?: Maybe<Scalars['UUID']>;
  quiz?: Maybe<Quiz>;
  contentId?: Maybe<Scalars['UUID']>;
  content?: Maybe<Content>;
  data: Scalars['JSON'];
  submissionId?: Maybe<Scalars['UUID']>;
  language?: Maybe<Scalars['LanguageCode']>;
};

export type QuestionAnswerList = {
   __typename?: 'QuestionAnswerList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<QuestionAnswer>;
};

export type QuestionContent = {
   __typename?: 'QuestionContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: QuestionContentData;
};

export type QuestionContentData = {
   __typename?: 'QuestionContentData';
  id?: Maybe<Scalars['UUID']>;
  question?: Maybe<Question>;
};

export type QuestionContentList = {
   __typename?: 'QuestionContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<QuestionContent>;
};

export type QuestionList = {
   __typename?: 'QuestionList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<Question>;
};

export type QuestionRefInput = {
  id: Scalars['UUID'];
  position: Scalars['Int'];
  navigation?: Maybe<Scalars['JSON']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  allowResponseEditing?: Maybe<Scalars['Boolean']>;
};

export enum QuestionType {
  MultipleChoice = 'multipleChoice',
  ToOrder = 'toOrder',
  TrueFalse = 'trueFalse',
  OpenText = 'openText',
  NumberSlider = 'numberSlider',
  StarRater = 'starRater',
  WordCloud = 'wordCloud'
}

export type Quiz = {
   __typename?: 'Quiz';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  publishedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  questionRefs?: Maybe<Array<SortableRef>>;
  questions: Array<Question>;
  realmRefs: Array<Ref>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<MediaImage>;
  scope?: Maybe<QuizScope>;
  enablePreview?: Maybe<Scalars['Boolean']>;
};


export type QuizI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type QuizContent = {
   __typename?: 'QuizContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: QuizContentData;
};

export type QuizContentData = {
   __typename?: 'QuizContentData';
  id?: Maybe<Scalars['UUID']>;
  quiz?: Maybe<Quiz>;
};

export type QuizContentList = {
   __typename?: 'QuizContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<QuizContent>;
};

export type QuizList = {
   __typename?: 'QuizList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<Quiz>;
};

export type QuizScope = {
   __typename?: 'QuizScope';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['LanguageCode']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  slug: Scalars['Slug'];
};


export type QuizScopeI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type QuizScopeList = {
   __typename?: 'QuizScopeList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<QuizScope>;
};

export type Realm = {
   __typename?: 'Realm';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  languages: Array<Scalars['String']>;
  title?: Maybe<Array<HtmlTranslation>>;
  abstract?: Maybe<Array<HtmlTranslation>>;
  description?: Maybe<Array<HtmlTranslation>>;
  i18n: PresentableResourceI18n;
  slug?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  collections: CollectionList;
  pointsOfInterest: PointOfInterestList;
};


export type RealmI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};


export type RealmCollectionsArgs = {
  pagination?: Maybe<PaginationArgs>;
};


export type RealmPointsOfInterestArgs = {
  pagination?: Maybe<PaginationArgs>;
};

export type Ref = {
   __typename?: 'Ref';
  id: Scalars['UUID'];
};

export type RefInput = {
  id: Scalars['UUID'];
};

export enum ResourceState {
  Published = 'published',
  Scheduled = 'scheduled',
  Draft = 'draft'
}

export type ResourceToPreload = {
   __typename?: 'ResourceToPreload';
  resourceType: ResourceType;
  id: Scalars['UUID'];
  language?: Maybe<Scalars['LanguageCode']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  target?: Maybe<I18nTarget>;
};

export enum ResourceType {
  AudioGuide = 'AudioGuide',
  AudioGuideTrack = 'AudioGuideTrack',
  Client = 'Client',
  Collection = 'Collection',
  Dataset = 'Dataset',
  Language = 'Language',
  MediaAudio = 'MediaAudio',
  MediaImage = 'MediaImage',
  MediaVideo = 'MediaVideo',
  Person = 'Person',
  PersonRole = 'PersonRole',
  PointOfInterest = 'PointOfInterest',
  Content = 'Content',
  ContentType = 'ContentType',
  Quiz = 'Quiz',
  QuizScope = 'QuizScope',
  Question = 'Question',
  QuestionAnswer = 'QuestionAnswer',
  Realm = 'Realm',
  User = 'User',
  Lock = 'Lock',
  Map = 'Map',
  Layer = 'Layer',
  Placeholder = 'Placeholder'
}

export type SearchResult = {
   __typename?: 'SearchResult';
  audioGuideTracks: Array<AudioGuideTrack>;
  audioGuides: Array<AudioGuide>;
  collections: Array<Collection>;
  pointsOfInterest: Array<PointOfInterest>;
  people: Array<Person>;
  quizzes: Array<Quiz>;
  questions: Array<Question>;
  mediaImages: Array<MediaImage>;
  mediaAudios: Array<MediaAudio>;
  mediaVideos: Array<MediaVideo>;
};



export type SortableRef = {
   __typename?: 'SortableRef';
  id: Scalars['UUID'];
  position: Scalars['Int'];
};

export type SortableRefInput = {
  id: Scalars['UUID'];
  position: Scalars['Int'];
};

export type SortArgs = {
  order?: Maybe<SortDirection>;
  field?: Maybe<SortField>;
};

export enum SortDirection {
  Ascending = 'ascending',
  Descending = 'descending'
}

export enum SortField {
  Id = 'id',
  CreatedAt = 'createdAt',
  UpdatedAt = 'updatedAt',
  Name = 'name',
  ShortCode = 'shortCode'
}

export type SortOptions = {
   __typename?: 'SortOptions';
  field: Scalars['String'];
  order: SortDirection;
};

export type StringTranslation = {
   __typename?: 'StringTranslation';
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: Scalars['String'];
};

export type StringTranslationInput = {
  language?: Maybe<Scalars['LanguageCode']>;
  target?: Maybe<I18nTarget>;
  value: Scalars['String'];
};

export type SurveyContent = {
   __typename?: 'SurveyContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: SurveyContentData;
};

export type SurveyContentData = {
   __typename?: 'SurveyContentData';
  id?: Maybe<Scalars['UUID']>;
  survey?: Maybe<Quiz>;
};

export type SurveyContentList = {
   __typename?: 'SurveyContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<SurveyContent>;
};

export type TextContent = {
   __typename?: 'TextContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: TextContentData;
};

export type TextContentData = {
   __typename?: 'TextContentData';
  body: Array<HtmlTranslation>;
  i18n: TextContentDataI18n;
};


export type TextContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type TextContentDataI18n = {
   __typename?: 'TextContentDataI18n';
  body?: Maybe<HtmlTranslation>;
};

export type TextContentDataInput = {
  body: Array<HtmlTranslationInput>;
};

export type TextContentList = {
   __typename?: 'TextContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<TextContent>;
};

export type TimelineContent = {
   __typename?: 'TimelineContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: TimelineContentData;
};

export type TimelineContentData = {
   __typename?: 'TimelineContentData';
  events: Array<TimelineContentEventData>;
  title: Array<HtmlTranslation>;
  text: Array<HtmlTranslation>;
  instruction?: Maybe<Array<HtmlTranslation>>;
  i18n: TimelineContentDataI18n;
  options?: Maybe<Scalars['JSON']>;
};


export type TimelineContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type TimelineContentDataI18n = {
   __typename?: 'TimelineContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  text?: Maybe<HtmlTranslation>;
  instruction?: Maybe<HtmlTranslation>;
};

export type TimelineContentDataInput = {
  events: Array<TimelineContentEventDataInput>;
  title: Array<HtmlTranslationInput>;
  text: Array<HtmlTranslationInput>;
  instruction: Array<HtmlTranslationInput>;
  options?: Maybe<Scalars['JSON']>;
};

export type TimelineContentEventData = {
   __typename?: 'TimelineContentEventData';
  id: Scalars['String'];
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<MediaImage>;
  text?: Maybe<Array<HtmlTranslation>>;
  date: Array<HtmlTranslation>;
  i18n?: Maybe<TimelineContentEventDataI18n>;
};


export type TimelineContentEventDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type TimelineContentEventDataI18n = {
   __typename?: 'TimelineContentEventDataI18n';
  text?: Maybe<HtmlTranslation>;
  date: HtmlTranslation;
};

export type TimelineContentEventDataInput = {
  id: Scalars['String'];
  text?: Maybe<Array<HtmlTranslationInput>>;
  date: Array<HtmlTranslationInput>;
  imageId?: Maybe<Scalars['UUID']>;
};

export type TimelineContentList = {
   __typename?: 'TimelineContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<TimelineContent>;
};

export type UpdateCollectionArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  style?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  pointOfInterestRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  lockRefs?: Maybe<Array<RefInput>>;
  duration?: Maybe<Scalars['Float']>;
  placeholderRefs?: Maybe<Array<RefInput>>;
};

export type UpdateLayerArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<UpdateMediaArgs>;
  data?: Maybe<Scalars['JSON']>;
  mapId?: Maybe<Scalars['UUID']>;
  position?: Maybe<GeometryPointInput>;
  scale?: Maybe<Scalars['Float']>;
  rotation?: Maybe<Scalars['Float']>;
  placeholders?: Maybe<Array<CreatePlaceholderArgs>>;
  geoPoints?: Maybe<Array<MapGeoPointInput>>;
};

export type UpdateMediaArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  credits?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdatePlaceholderArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  shortCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaceholderType>;
  imageId?: Maybe<Scalars['UUID']>;
  image?: Maybe<UpdateMediaArgs>;
  data?: Maybe<Scalars['JSON']>;
  target?: Maybe<Scalars['JSON']>;
  position?: Maybe<GeometryPointInput>;
  marker?: Maybe<Scalars['JSON']>;
  parentId?: Maybe<Scalars['UUID']>;
  parent?: Maybe<UpdatePlaceholderArgs>;
  children?: Maybe<Array<CreatePlaceholderArgs>>;
  layerId?: Maybe<Scalars['UUID']>;
  layer?: Maybe<UpdateLayerArgs>;
  pointOfInterestId?: Maybe<Scalars['UUID']>;
  pointOfInterest?: Maybe<UpdatePointOfInterestInput>;
  collectionId?: Maybe<Scalars['UUID']>;
  collection?: Maybe<UpdateCollectionArgs>;
  duration?: Maybe<Scalars['Float']>;
  index?: Maybe<Scalars['Float']>;
};

export type UpdatePointOfInterestInput = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  style?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  imageId?: Maybe<Scalars['UUID']>;
  contentRefs?: Maybe<Array<PointOfInterestContentRefInput>>;
  personRefs?: Maybe<Array<PersonRefInput>>;
  audioGuideTrackRefs?: Maybe<Array<SortableRefInput>>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  lockRefs?: Maybe<Array<RefInput>>;
  duration?: Maybe<Scalars['Float']>;
  placeholderRefs?: Maybe<Array<RefInput>>;
};

export type UpdatePresentableResourceArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
};

export type UpdateResourceArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateStylizedPresentableResourceArgs = {
  id: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  languages?: Maybe<Array<Scalars['LanguageCode']>>;
  title?: Maybe<Array<HtmlTranslationInput>>;
  abstract?: Maybe<Array<HtmlTranslationInput>>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  style?: Maybe<Scalars['JSON']>;
};


export type UseContextConsumer = {
   __typename?: 'UseContextConsumer';
  type: ResourceType;
  subtype?: Maybe<ContentTypeSlug>;
  id: Scalars['String'];
  info?: Maybe<ConsumerInfo>;
};

export type User = {
   __typename?: 'User';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userAgent: Scalars['String'];
  language: Scalars['LanguageCode'];
};


export type VideoContent = {
   __typename?: 'VideoContent';
  id: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: ContentType;
  slug?: Maybe<Scalars['Slug']>;
  name?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  languages: Array<Scalars['LanguageCode']>;
  people: Array<PersonWithRole>;
  options?: Maybe<Scalars['JSONObject']>;
  enablePreview?: Maybe<Scalars['Boolean']>;
  data: VideoContentData;
};

export type VideoContentData = {
   __typename?: 'VideoContentData';
  title: Array<HtmlTranslation>;
  description: Array<HtmlTranslation>;
  videoRefs: Array<I18nRef>;
  video: Array<MediaVideoTranslation>;
  i18n: VideoContentDataI18n;
};


export type VideoContentDataI18nArgs = {
  target?: Maybe<I18nTarget>;
  languages: Array<Scalars['LanguageCode']>;
};

export type VideoContentDataI18n = {
   __typename?: 'VideoContentDataI18n';
  title?: Maybe<HtmlTranslation>;
  description?: Maybe<HtmlTranslation>;
  video?: Maybe<MediaVideoTranslation>;
};

export type VideoContentDataInput = {
  title: Array<HtmlTranslationInput>;
  description?: Maybe<Array<HtmlTranslationInput>>;
  videoRefs: Array<I18nRefInput>;
};

export type VideoContentList = {
   __typename?: 'VideoContentList';
  itemsCount: Scalars['Int'];
  totalCount: Scalars['Int'];
  pagination?: Maybe<PaginationOptions>;
  sort?: Maybe<SortOptions>;
  items: Array<VideoContent>;
};

export type VideoFile = {
   __typename?: 'VideoFile';
  url: Scalars['String'];
  hash: Scalars['SHA1'];
  name: Scalars['String'];
  contentType: Scalars['String'];
  size: Scalars['Int'];
  duration: Scalars['Float'];
};

export type VideoScreenshot = {
   __typename?: 'VideoScreenshot';
  url: Scalars['String'];
  hash: Scalars['SHA1'];
  name: Scalars['String'];
  contentType: Scalars['String'];
  size: Scalars['Int'];
  time: Scalars['Float'];
};
